import script from "./UserSubscriptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSubscriptions.vue?vue&type=script&setup=true&lang=ts"

import "./UserSubscriptions.vue?vue&type=style&index=0&id=5d1fa9fe&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d1fa9fe"]])

export default __exports__